import React, { useState, useEffect } from 'react';
import { cn } from '../utils/cn';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
    delayMs?: number;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 'md',
    className,
    delayMs = 200
}) => {
    const [show, setShow] = useState(delayMs === 0);

    useEffect(() => {
        if (delayMs === 0) return;
        const timer = setTimeout(() => { setShow(true); }, delayMs);
        return () => { clearTimeout(timer); };
    }, [delayMs]);

    const sizeClasses = {
        sm: 'h-4 w-4 border-2',
        md: 'h-8 w-8 border-3',
        lg: 'h-12 w-12 border-4',
    };

    if (!show) {
        return <div className={cn("flex justify-center items-center opacity-0", className)}>
             <div className={cn(sizeClasses[size])} />
        </div>;
    }

    return (
        <div className={cn("flex justify-center items-center animate-in fade-in duration-300", className)}>
            <div
                className={cn(
                    "animate-spin rounded-full border-primary-200 border-t-primary-600",
                    sizeClasses[size]
                )}
            />
        </div>
    );
};
